import React, { useEffect, useState } from "react";
import Header from "../Include/Header";
import Sidebar from "../Include/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getCategory } from "../../../Store/Store/StoreMaster/Category/Category";
import { getUnit } from "../../../Store/Store/StoreMaster/Unit/Unit";
import Footer from "../Include/Footer";
import { addItem } from "../../../Store/Store/Item/ManageItem";
import { getLocation } from "../../../Store/Store/StoreMaster/InventoryLocation/Location";
import { Dropdown } from "primereact/dropdown";
import { getScheduleMaster } from "../../../Store/prosafe/master/schedule/getSchedule";
import { getClassMaster } from "../../../Store/prosafe/master/class/getClass";
import { getMocMaster } from "../../../Store/prosafe/master/moc/getMoc";
import { PlusCircle } from "lucide-react";
import UnitModal from "../../../Components/Item/UnitModal";
import { addUnit } from "../../../Store/Store/StoreMaster/Unit/ManageUnit";
import { addCategory } from "../../../Store/Store/StoreMaster/Category/ManageCategory";
import CategoryModal from "../../../Components/Item/CategoryModal";
import { addLocation } from "../../../Store/Store/StoreMaster/InventoryLocation/ManageLocation";
import LocationModal from "../../../Components/Item/LocationModal";
import { getItemCompany } from "../../../Store/Store/StoreMaster/ItemCompany/getItemCompany";

const ManageItem = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const data = location.state;

  const initialItemState = {
    name: "",
    itemCompanyId: "",
    unit: "",
    hsn_code: "",
    gst_percentage: 0,
    purchase_rate: 0,
    sale_rate: 0,
    // cost_rate: 0,
    reorder_quantity: 0,
    is_service_item: false,
    category: "",
    material_grade: "",
    detail: "",
    in_location: "",
    mcode: "",
    // mocId: "",
    // scheduleId: "",
    // classId: "",
    // thickness: "",
    // item_extra_spec: "",
  };

  const [item, setItem] = useState(initialItemState);
  const [disable, setDisable] = useState(false);
  const [error, setError] = useState("");
  const [selectValue, setSelectValue] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [thicknessDisabled, setThicknessDisabled] = useState(false);

  const [modal, setModal] = useState({
    unit: false,
    category: false,
    location: false,
  });

  const [unit, setUnit] = useState({
    name: "",
    disable: "",
    error: "",
  });

  const [categoryDetails, setCategoryDetails] = useState({
    name: "",
    disable: "",
    error: "",
  });

  const [locationDetails, setLocationDetails] = useState({
    name: "",
    address: "",
    disable: "",
    error: {},
  });

  // Select options data
  const categoryData = useSelector((state) => state?.getCategory?.user?.data);
  const unitData = useSelector((state) => state?.getUnit?.user?.data);
  const locationData = useSelector((state) => state?.getLocation?.user?.data);
  const scheduleData = useSelector(
    (state) => state?.getScheduleMaster?.user?.data
  );
  const classData = useSelector((state) => state?.getClassMaster?.user?.data);
  const mocData = useSelector((state) => state?.getMocMaster?.user?.data);

  const openModal = (type) => setModal((prev) => ({ ...prev, [type]: true }));
  const closeModal = (type) => setModal((prev) => ({ ...prev, [type]: false }));

  const resetLocation = () =>
    setLocationDetails({ name: "", address: "", error: {}, disable: false });

  const resetUnit = () => setUnit({ name: "", error: "", disable: false });

  const resetCategory = () =>
    setCategoryDetails({ name: "", error: "", disable: false });

  const handleUnitSubmit = () => {
    if (!unit.name.trim()) {
      setUnit((prev) => ({ ...prev, error: "Please enter Unit name" }));
      return;
    }

    setUnit((prev) => ({ ...prev, disable: true }));
    const bodyFormData = new URLSearchParams();
    bodyFormData.append("name", unit.name.trim());

    dispatch(addUnit(bodyFormData))
      .then((res) => {
        if (res.payload.success === true) {
          dispatch(getUnit());
          closeModal("unit");
          resetUnit();
        }
        setUnit((prev) => ({ ...prev, disable: false }));
      })
      .catch((error) => {
        console.log(error, "Error");
        setUnit((prev) => ({ ...prev, disable: false }));
      })
      .finally(() => {
        setUnit((prev) => ({ ...prev, disable: false }));
      });
  };

  const handleCategorySubmit = () => {
    if (!categoryDetails.name.trim()) {
      setCategoryDetails((prev) => ({
        ...prev,
        error: "Please enter Category name",
      }));
      return;
    }

    const formData = new URLSearchParams();
    formData.append("name", categoryDetails.name);

    setCategoryDetails((prev) => ({ ...prev, disable: true }));
    dispatch(addCategory(formData))
      .then((res) => {
        if (res.payload.success === true) {
          dispatch(getCategory());
          closeModal("category");
          resetCategory();
        }
        setCategoryDetails((prev) => ({ ...prev, disable: false }));
      })
      .catch((error) => {
        console.log(error, "Error");
        setCategoryDetails((prev) => ({ ...prev, disable: false }));
      })
      .finally(() => {
        setCategoryDetails((prev) => ({ ...prev, disable: false }));
      });
  };

  const handleLocationSubmit = () => {
    const newErrors = {};

    if (!locationDetails.name.trim()) {
      newErrors.name = "Please enter name";
    }

    if (!locationDetails.address.trim()) {
      newErrors.address = "Please enter Address";
    }

    if (Object.keys(newErrors).length > 0) {
      setLocationDetails((prev) => ({ ...prev, error: newErrors }));
      return;
    }

    const formData = new URLSearchParams();
    formData.append("name", locationDetails.name);
    formData.append("address", locationDetails.address);

    setLocationDetails((prev) => ({ ...prev, error: {}, disable: true }));

    dispatch(addLocation(formData))
      .then((res) => {
        if (res?.payload?.success === true) {
          dispatch(getLocation());
          closeModal("location");
          resetLocation();
        }
        setLocationDetails((prev) => ({ ...prev, disable: false }));
      })
      .catch((error) => {
        console.log(error, "Error");
        setLocationDetails((prev) => ({ ...prev, disable: false }));
      })
      .finally(() => {
        setLocationDetails((prev) => ({ ...prev, disable: false }));
      });
  };

  const generateOptions = (
    data,
    labelKey,
    valueKey = "_id",
    thicknessKey = null
  ) =>
    data?.map((item) => ({
      label: thicknessKey
        ? `${item[labelKey]}${item[thicknessKey] ? ` (${item[thicknessKey]})` : ""
        }`
        : item[labelKey],
      value: item[valueKey],
      thickness: thicknessKey ? item[thicknessKey] : null,
    }));

  // const generateOptions = (data, labelKey, valueKey = '_id', thicknessKey = null) => {
  //   const options = data?.map(item => ({
  //     label: thicknessKey ? `${item[labelKey]}${item[thicknessKey] ? ` (${item[thicknessKey]})` : ''}` : item[labelKey],
  //     value: item[valueKey],
  //     thickness: thicknessKey ? item[thicknessKey] : null
  //   })) || [];

  //   // Add default reset option at the top
  //   return [{ label: `-- Select ${labelKey.charAt(0).toUpperCase() + labelKey.slice(1)} --`, value: null }, ...options];
  // };

  const ItemCompanyData = useSelector(
    (state) => state?.getStoreItemCompany?.user?.data
  );

  const itemCompanyOption = generateOptions(ItemCompanyData, "name");
  const unitOption = generateOptions(unitData, "name");
  const catOptions = generateOptions(categoryData, "name");
  const locationOptions = generateOptions(locationData, "name");
  const scheduleOptions = generateOptions(
    scheduleData,
    "schedule",
    "_id",
    "thickness"
  );
  const classOptions = generateOptions(
    classData,
    "className",
    "_id",
    "thickness"
  );
  const mocOptions = generateOptions(mocData, "name");
  const itemSpecData = [
    { value: "seamless", label: "Seamless" },
    { value: "erw", label: "Erw" },
  ];

  useEffect(() => {
    if (location.state) {
      setItem({
        ...initialItemState,
        name: location.state?.name,
        itemCompanyId: location.state?.itemCompanyId,
        unit: location.state.unit?._id,
        hsn_code: location.state?.hsn_code,
        gst_percentage: location.state?.gst_percentage,
        purchase_rate: location.state?.purchase_rate,
        sale_rate: location.state?.sale_rate,
        // cost_rate: location.state?.cost_rate,
        reorder_quantity: location.state?.reorder_quantity,
        is_service_item: location.state?.is_service_item ?? false,
        category: location.state.category?._id,
        material_grade: location.state?.material_grade,
        detail: location.state?.detail,
        in_location: location.state?.location?._id,
        mcode: location.state.mcode,
        // mocId: location.state?.mocId?._id,
        // scheduleId: location.state?.scheduleId?._id,
        // classId: location.state?.classId?._id,
        thickness: location.state?.thickness,
        // item_extra_spec: location.state.item_extra_spec,
      });
      setSelectValue(location.state?.status);
      if (location.state?.scheduleId || location.state?.classId) {
        setThicknessDisabled(true);
      }
    }
  }, [location.state]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          dispatch(getCategory()),
          dispatch(getUnit()),
          dispatch(
            getItemCompany({
              status: "true",
            })
          ),
          dispatch(getLocation()),
          dispatch(getScheduleMaster({ payload: {} })),
          dispatch(getClassMaster({ payload: {} })),
          dispatch(getMocMaster({ payload: {} })),
        ]);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };
    fetchData();
  }, []);


  const handleChange = (e) => {
    setItem({ ...item, [e.target.name]: e.target.value });
  };

  const handleDropdownChange = (e, name) => {
    const newItem = { ...item, [name]: e.value };

    // Auto-fill thickness logic
    if (name === "scheduleId" || name === "classId") {
      const selectedOption =
        name === "scheduleId"
          ? scheduleData?.find((s) => s._id === e.value)
          : classData?.find((c) => c._id === e.value);

      if (selectedOption?.thickness) {
        newItem.thickness = selectedOption.thickness;
        setThicknessDisabled(true);
      } else {
        newItem.thickness = "";
        setThicknessDisabled(false);
      }

      // Clear the other field if one is selected
      if (name === "scheduleId") {
        newItem.classId = "";
      } else if (name === "classId") {
        newItem.scheduleId = "";
      }
    }

    setItem(newItem);
  };

  const handleRadioChange = (event) => {
    setSelectValue(event.target.checked);
  };

  const handleKeyDown = (e) => {
    if (["ArrowUp", "ArrowDown"].includes(e.key)) e.preventDefault();
  };

  const validation = () => {
    const requiredFields = {
      name: "Please enter name",
      unit: "Please select unit",
      category: "Please select category",
      in_location: "Please select location",
      hsn_code: "Please enter hsn",
      // mcode: "Please enter mcode",
      // mocId: "Please select MOC",
    };

    const errors = {};
    Object.entries(requiredFields).forEach(([field, message]) => {
      if (!item[field]) errors[`${field}_err`] = message;
    });

    setError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = () => {
    if (validation()) {
      setDisable(true);
      const payload = {
        firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
        year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
        name: item.name,
        itemCompanyId: item.itemCompanyId ? item.itemCompanyId : null,
        unit: item.unit,
        hsn_code: item.hsn_code,
        gst_percentage: item.gst_percentage === "" ? 0 : item.gst_percentage,
        purchase_rate: item.purchase_rate === "" ? 0 : item.purchase_rate,
        sale_rate: item.sale_rate === "" ? 0 : item.sale_rate,
        reorder_quantity: item.reorder_quantity === "" ? 0 : item.reorder_quantity,
        is_service_item: item.is_service_item,
        category: item.category,
        material_grade: item.material_grade,
        detail: item.detail,
        location: item.in_location,
        mcode: item.mcode,
      };

      // if (item.thickness) {
      //   payload.thickness = item.thickness;
      // }

      if (data?._id) {
        payload.id = data._id;
        payload.status = selectValue;
      }

      dispatch(addItem(payload))
        .then((res) => {
          if (res.payload.success === true) {
            navigate("/main-store/user/item-management");
          }
          setDisable(false);
        })
        .catch((error) => {
          setDisable(false);
        });
    }
  };

  const handleReset = () => {
    setItem(initialItemState);
    setThicknessDisabled(false);
  };
  const handleOpen = () => setIsSidebarOpen(!isSidebarOpen);

  const renderInputField = (
    label,
    name,
    type = "text",
    required = false,
    extraProps = {}
  ) => (
    <div className="col-12 col-md-4 col-xl-4">
      <div className="input-block local-forms">
        <label>
          {label} {required && <span className="login-danger">*</span>}
        </label>
        <input
          className="form-control"
          type={type}
          onChange={handleChange}
          name={name}
          value={item[name]}
          disabled={name === "thickness" ? thicknessDisabled : false}
          {...extraProps}
        />
        {error[`${name}_err`] && (
          <div className="error">{error[`${name}_err`]}</div>
        )}
      </div>
    </div>
  );

  // Render dropdown field helper
  const renderDropdown = (
    label,
    name,
    options,
    required = false,
    onClick = null
  ) => (
    <div className="col-12 col-md-4 col-xl-4">
      <div className="input-block local-forms custom-select-wpr">
        <label>
          {label} {required && <span className="login-danger">*</span>}
        </label>

        <div className="d-flex gap-2">
          <div className="flex-grow-1">
            <Dropdown
              options={options}
              value={item[name]}
              onChange={(e) => handleDropdownChange(e, name)}
              filter
              className="w-100"
              placeholder={`Select ${label}`}
            />
          </div>

          {onClick && (
            <button
              type="button"
              className="btn btn-sm btn-outline-primary mt-1 d-flex align-items-center justify-content-center"
              style={{ width: "40px", height: "38px" }}
              data-bs-toggle="tooltip"
              data-bs-title={`Add ${label}`}
              onClick={onClick}
            >
              <PlusCircle size={16} />
            </button>
          )}
        </div>
        {error[`${name}_err`] && (
          <div className="error">{error[`${name}_err`]}</div>
        )}
      </div>
    </div>
  );

  useEffect(() => {
    setTimeout(() => {
      const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
      );
      tooltipTriggerList.forEach((tooltipTriggerEl) => {
        new window.bootstrap.Tooltip(tooltipTriggerEl);
      });
    }, 0);
  }, []);

  return (
    <>
      <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
        <Header handleOpen={handleOpen} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/main-store/user/dashboard">Dashboard </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right"></i>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/main-store/user/item-management">
                        Item List
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right"></i>
                    </li>
                    <li className="breadcrumb-item active">
                      {data?._id ? "Edit" : "Add"} Item
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form>
                      <div className="col-12">
                        <div className="form-heading">
                          <h4>{data?._id ? "Edit" : "Add"} Item Details</h4>
                        </div>
                      </div>

                      <div className="row">
                        {renderInputField("Name", "name", "text", true)}
                        {renderDropdown(
                          "Item Company Name",
                          "itemCompanyId",
                          itemCompanyOption
                        )}
                        {renderDropdown("Unit", "unit", unitOption, true, () =>
                          openModal("unit")
                        )}
                        {renderDropdown(
                          "Category",
                          "category",
                          catOptions,
                          true,
                          () => openModal("category")
                        )}
                        {renderInputField("HSN", "hsn_code", "number", true)}
                        {renderInputField("Grade", "material_grade")}
                        {renderInputField("MCode", "mcode", "text")}
                        {/* {renderDropdown("Schedule", "scheduleId", scheduleOptions, true)}
                      {renderDropdown("Class", "classId", classOptions, true)}
                      {renderDropdown("MOC", "mocId", mocOptions, true)} */}
                        {/* {renderInputField("Thickness", "thickness", "text")} */}
                        {renderInputField(
                          "GST(%)",
                          "gst_percentage",
                          "number",
                          false,
                          {
                            onWheel: (e) => e.target.blur(),
                            onKeyDown: handleKeyDown,
                          }
                        )}
                        {renderInputField(
                          "Purchase Rate",
                          "purchase_rate",
                          "number",
                          false,
                          {
                            onWheel: (e) => e.target.blur(),
                            onKeyDown: handleKeyDown,
                          }
                        )}
                        {renderInputField(
                          "Sale Rate",
                          "sale_rate",
                          "number",
                          false,
                          {
                            onWheel: (e) => e.target.blur(),
                            onKeyDown: handleKeyDown,
                          }
                        )}
                        {/* {renderInputField("Cost", "cost_rate", "number", false, {
                        onWheel: (e) => e.target.blur(),
                        onKeyDown: handleKeyDown
                      })} */}
                        {renderInputField(
                          "Reorder Quantity",
                          "reorder_quantity",
                          "number",
                          false,
                          {
                            onWheel: (e) => e.target.blur(),
                            onKeyDown: handleKeyDown,
                          }
                        )}
                        {renderDropdown(
                          "Location",
                          "in_location",
                          locationOptions,
                          true,
                          () => openModal("location")
                        )}
                        {/* {renderDropdown("Item (Seamless/ERW)", "item_extra_spec", itemSpecData, true)} */}

                        <div className="col-12 col-md-4 col-xl-4">
                          <div className="cardNum">
                            <div className="mb-3">
                              <label className="form-label">Is Service Item?</label>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  name="is_service_item"
                                  onChange={(e) =>
                                    setItem((prev) => ({
                                      ...prev,
                                      is_service_item: e.target.checked,
                                    }))
                                  }
                                  checked={Boolean(item.is_service_item)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        {data?._id ? (
                          <div className="col-12 col-md-4 col-xl-4">
                            <div className="cardNum">
                              <div className="mb-3">
                                <label
                                  htmlFor="fileUpload"
                                  className="form-label"
                                >
                                  Status
                                </label>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    onChange={handleRadioChange}
                                    checked={selectValue}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}

                        <div className="col-12 col-md-12 col-xl-12">
                          <div className="input-block local-forms">
                            <label> Details</label>
                            <textarea
                              className="form-control"
                              type="text"
                              onChange={handleChange}
                              name="detail"
                              value={item.detail}
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                    <div className="col-12">
                      <div className="doctor-submit text-end">
                        <button
                          type="button"
                          className="btn btn-primary submit-form me-2"
                          onClick={handleSubmit}
                          disabled={disable}
                        >
                          {disable
                            ? "Processing..."
                            : data?._id
                              ? "Update"
                              : "Submit"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary cancel-form"
                          onClick={handleReset}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>

      <UnitModal
        show={modal.unit}
        onClose={() => {
          closeModal("unit");
          resetUnit();
        }}
        unit={unit.name}
        setUnit={(value) =>
          setUnit((prev) => ({ ...prev, name: value, error: "" }))
        }
        unitError={unit.error}
        onSubmit={handleUnitSubmit}
        disableSubmit={unit.disable}
      />

      <CategoryModal
        show={modal.category}
        onClose={() => {
          closeModal("category");
          resetCategory();
        }}
        category={categoryDetails.name}
        setCategory={(value) =>
          setCategoryDetails((prev) => ({ ...prev, name: value, error: "" }))
        }
        categoryError={categoryDetails.error}
        onSubmit={handleCategorySubmit}
        disableSubmit={categoryDetails.disable}
      />

      <LocationModal
        show={modal.location}
        onClose={() => {
          closeModal("location");
          resetLocation();
        }}
        location={locationDetails}
        setLocation={(field, value) =>
          setLocationDetails((p) => ({ ...p, [field]: value }))
        }
        locationError={locationDetails.error}
        onSubmit={handleLocationSubmit}
        disableSubmit={locationDetails.disable}
      />
    </>
  );
};

export default ManageItem;
